import type { components } from "@/api-schema";
import type { RowWithIdentifier } from "@/components/data-table/_helpers/row-identifier";
import { EMPTY_VALUE_PLACEHOLDER } from "@/components/ui/empty-value";

type VehicleValuationRow = components["schemas"]["VehicleValuation"] & RowWithIdentifier;

export const renderVehicleValuationTitle = (row: VehicleValuationRow): string => {
  const brandName = row.vehicle?.modelGeneration?.modelFamily?.brand?.name;
  const modelName =
    row.vehicle?.modelDescription ||
    row.vehicle?.modelGeneration?.name ||
    row.vehicle?.modelGeneration?.modelFamily?.name;
  const fallbackVin = row.vinUsed;

  return [brandName, modelName].filter(Boolean).join(" ") || fallbackVin || EMPTY_VALUE_PLACEHOLDER;
};
